var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.56 9.473a7.493 7.493 0 00-.075-.53l1.884-2.827a.5.5 0 00-.574-.752l-2.62.874a5.055 5.055 0 00-.618-.753c-.555-.555-1.424-1.147-2.604-1.147-1.222 0-2.127.343-2.773.904-.64.556-.977 1.285-1.15 1.975a6.49 6.49 0 00-.162 1.865c.007.145.018.277.03.39-1.256.267-2.569-.142-3.856-.905C6.624 7.725 5.323 6.5 4.307 5.485a.5.5 0 00-.854.338c-.127 4.077.714 9.011 4.511 11.513-1.597.865-3.163 1.268-5.073 1.506a.5.5 0 00-.161.944c5.158 2.579 11.843 2.392 15.623-2.648 1.567-2.089 2.092-4.184 2.223-5.758.066-.786.033-1.444-.016-1.907z",
    fill: "#fff"
  })));
}

export default SvgTwitter;